import React, { useState } from 'react'
import {
  Grid,
  Box,
  Modal,
  FormControl,
  TextField,
  Button,
  FormControlLabel,
  Checkbox,
} from '@material-ui/core'
import { insertGenderActivities } from '../../../../../services/Elegibilidad/create'
import swal from 'sweetalert'
import { useFormElegibilidad } from '../../../../../context/ElegibilidadContext'

export const Modal41 = ({ open, setOpen, getDataTable }) => {
  const { idElegibilityForm } = useFormElegibilidad()

  const [activityAnswer, setActivityAnswer] = useState('')
  const [womenCheck, setWomencheck] = useState(false)
  const [menCheck, setMencheck] = useState(false)
  const [descriptionAnswer, setDescriptionAnswer] = useState('')
  const [loading, setLoading] = useState(false)

  const handleGuardar = async () => {
    setLoading(true)
    const body = {
      IdGenderActivity: 0,
      IdElegibilityAnswer: idElegibilityForm,
      IdActivity: 1,
      ActivityDetail: activityAnswer,
      Men: menCheck,
      Women: womenCheck,
      Description: descriptionAnswer,
      isDefault: false,
    }

    if (
      activityAnswer === '' ||
      descriptionAnswer === '' ||
      (menCheck === false && womenCheck === false)
    ) {
      setLoading(false)
      swal({
        title:
          'Favor validar: si hay errores o campos pendientes por completar',
        icon: 'warning',
        button: 'Entendido',
      })
    } else {
      const response = await insertGenderActivities(body)
      if (response.Success) {
        swal({
          title: '¡Datos guardados exitosamente!',
          icon: 'success',
        })
        getDataTable()
        handleClose()
        setLoading(false)
      }
    }
  }

  const handleClose = () => {
    setOpen(false)
    setActivityAnswer('')
    setWomencheck(false)
    setMencheck(false)
    setDescriptionAnswer('')
    setLoading(false)
  }
  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="modalPYME">
          <div className="pymeDiv">
            <h1 className="pymeTitle">Datos de la actividad</h1>
          </div>

          <Grid container spacing={1} className="input__container">
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">Actividad</label>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <FormControl style={{ width: '100%' }}>
                <TextField
                  id="MiPymeCountry"
                  name="MiPymeCountry"
                  type="text"
                  variant="outlined"
                  sx={{ width: 220 }}
                  onChange={(e) => {
                    setActivityAnswer(e.target.value)
                  }}
                  inputProps={{
                    maxLength: 100,
                  }}
                />
              </FormControl>
            </Grid>

            <Grid item xs={6} sm={6} md={6}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={menCheck}
                    onChange={(e) => {
                      setMencheck(e.target.checked)
                    }}
                    name="man"
                  />
                }
                label="Realizado por hombres"
              />
            </Grid>
            <Grid item xs={6} sm={6} md={6}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={womenCheck}
                    onChange={(e) => {
                      setWomencheck(e.target.checked)
                    }}
                    name="women"
                  />
                }
                label="Realizado por mujeres"
              />
            </Grid>

            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">Describir actividad</label>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <FormControl style={{ width: '100%' }}>
                <textarea
                  placeholder="Actividad"
                  customInput={TextField}
                  onChange={(e) => {
                    setDescriptionAnswer(e.target.value)
                  }}
                  maxLength={200}
                ></textarea>
              </FormControl>
            </Grid>

            <Grid className="buttonsPYME">
              <Button className="cancelButton" onClick={() => handleClose()}>
                Cancelar
              </Button>
              <Button
                className="confirmButton"
                disabled={loading}
                onClick={handleGuardar}
              >
                Guardar
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </>
  )
}
